import React from "react";

import PublicRoutes from "./routes/index";
import "./App.css";
// import ComingSoon from "./components/pages/ComingSoon";

// Add the next line to see the application
// localStorage.setItem("COMING_SOON_IRELAND", true);
const App = () => {
  // const displayConditionallyComingSoonPage =
  //   !!localStorage.getItem("COMING_SOON_IRELAND");
  return (
    <React.Fragment>
      <PublicRoutes />
      {/* {!displayConditionallyComingSoonPage ? <ComingSoon /> : <PublicRoutes />} */}
    </React.Fragment>
  );
};
export default App;
